import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-64" data-mp="4uqdmw6js2tb">
      <div className="max-w-2xl mx-auto text-center" data-id="element-65" data-mp="4xck0shpcc9y">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6" data-id="element-66" data-mp="9u37i0vu6a5e">
          <ShieldCheckIcon className="w-8 h-8 text-brand-green" aria-hidden="true" data-id="element-67" data-mp="eu8tb0ffd2fk" />
        </div>

        <h2 className="text-2xl md:text-3xl font-black text-brand-text mb-6 uppercase tracking-wide text-balance" data-id="element-68" data-mp="jqg00vfnahyk">
          Recuperá tu tiempo o te devolvemos la plata
        </h2>

        <p className="text-brand-gray mb-6 leading-relaxed" data-id="element-69" data-mp="slmc2c5idw9j">
          7 días de garantía y sin preguntas. Si no es lo que esperabas, te
          devolvemos el 100%. Nos escribís un mail y listo.
        </p>

        <a href="#pricing" className="text-sm font-bold text-brand-text underline underline-offset-4 transition-colors duration-150 ease-smooth hover:text-brand-green" data-id="element-70" data-mp="12gxhu4yxvt55">
          Política de reembolso completa
        </a>
      </div>
    </section>;
}